export default __webpack_public_path__ + "static/media/GuideTags.1aba2878.svg";